<template>
  <v-dialog v-model="dialogActive" width="600">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>Add Performance</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <date-picker v-model="date" label="Performance Date" outlined />
          </v-col>
          <v-col>
            <time-picker v-model="time" label="Performance Time" outlined />
          </v-col>
          <v-col>
            <v-text-field v-model="tickets" label="Ticket Count" type="number" outlined />
          </v-col>
        </v-row>
        <p>Below are the price options. Student and Employee prices are special and require a login to access, all other prices will be available to everyone.</p>
        <p class="mb-6">The Ticket Limit is how many tickets can be purchased at that price (total in the case of Student/Employee tickets, per-transaction for others). Leave it blank for no limit.</p>
        <v-row v-for="({ label, price, limit }, index) of prices" :key="'price-' + index">
          <v-col>
            <v-combobox :value="label" :items="['Covenant Student', 'Covenant Faculty/Staff', 'Community Adult', 'Community Student/Elder']" label="Price Label" outlined hide-details @change="(label) => updatePrice(index, { label })" />
          </v-col>
          <v-col>
            <v-text-field :value="price" label="Price Amount" type="number" outlined hide-details @change="(price) => updatePrice(index, { price })" />
          </v-col>
          <v-col>
            <v-text-field :value="limit" label="Ticket Limit" type="number" hint="Leave blank for no limit" outlined hide-details clearable @change="(limit) => updatePrice(index, { limit })" />
          </v-col>
        </v-row>
        <v-btn class="mt-4" @click="prices.push({ label: '', price: 0, limit: null })">Add Price Option</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="isAdding || !date || !time" text @click="addPerformance()">Add Performance</v-btn>
        <v-spacer />
        <v-btn text @click="dialogActive = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, computed, watch } from '@vue/composition-api'

export default {
  components: {
    DatePicker: () => import('@/components/forms/inputs/DatePicker'),
    TimePicker: () => import('@/components/forms/inputs/TimePicker')
  },
  props: {
    showId: { type: String, required: true },
    value: Boolean
  },
  setup (props, { root, emit }) {
    const user = computed(() => 'spoof' in root.$store.state.user ? root.$store.state.user.spoof : root.$store.state.user)
    const isLoggedIn = computed(() => root.$store.state.loggedIn)
    const isAdmin = computed(() => isLoggedIn.value && user.value.roles.includes('Technology Services'))

    const dialogActive = ref(false)
    watch(() => props.value, () => {
      console.log(`props.value changed: ${props.value}`)
      if (props.value !== dialogActive.value) dialogActive.value = props.value
    })
    watch(dialogActive, () => {
      if (props.value !== dialogActive.value) emit('input', dialogActive.value)
    })

    const date = ref('')
    const time = ref('19:00')
    const location = ref('Sanderson Auditorium')
    const tickets = ref(200)
    const prices = ref([])

    function updatePrice (index, upd) {
      prices.value.splice(index, 1, { ...prices.value[index], ...upd })
    }
    const isAdding = ref(false)

    async function addPerformance () {
      isAdding.value = true
      const obj = {
        date: new Date(date.value + ' ' + time.value),
        location: location.value,
        tickets: tickets.value,
        prices: prices.value
      }
      const res = await root.$feathers.service('theatre/show').patch(props.showId, { $push: { performances: obj } })
      const performances = res.performances.sort((a, b) => new Date(a.date) < new Date(b.date) ? -1 : 1).map((row) => {
        const dt = new Date(row.date)
        const date = dt.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
        const time = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' })
        row.dateStr = `${date} at ${time}`
        return row
      })
      emit('updated', { performances })
      isAdding.value = false
      dialogActive.value = false
    }

    return {
      user,
      isLoggedIn,
      isAdmin,
      dialogActive,
      date,
      time,
      location,
      tickets,
      prices,
      updatePrice,
      isAdding,
      addPerformance
    }
  }
}
</script>
